import { SxProp, useDripsyTheme, View } from 'dripsy';
import { Svg, G, Path, Rect, Text } from 'react-native-svg';
import React from 'react';

export interface DonutChartItem {
  arc: string | null;
  textPosition: [number, number];
  item: { name: string; percentage: number; value: string };
  selectArc: () => void;
}

export interface DonutChartData extends Array<DonutChartItem> {}

interface DonutChartProps {
  radius?: number;
  sx?: SxProp;
  donutChartData: DonutChartData;
}

export const DonutChart: React.FC<DonutChartProps> = ({ radius = 100, donutChartData, sx }) => {
  const [width, height] = [radius * 2, radius * 2];

  const { theme } = useDripsyTheme();
  const colors = [theme.colors?.$pieChart0, theme.colors?.$pieChart1, theme.colors?.$pieChart2, theme.colors?.$pieChart3];

  if (donutChartData.length === 0) {
    return (
      <View sx={{ ...styles.emptyContainer, width, height, ...sx }}>
        <View sx={styles.emptyChart}>
          <View sx={styles.emptyChartInnerRadius} />
        </View>
      </View>
    );
  }

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <Svg width={width} height={height}>
        <Rect width={width} height={height} fill="transparent" />
        {donutChartData.map((item, index) => {
          const [hovered, setHovered] = React.useState(false);
          return (
            <G transform={`translate(${radius}, ${radius})`} key={`donutChart-${index}-${item.item.name}`}>
              <Path
                key={index}
                d={item.arc?.toString() || ''}
                fill={colors[index] as string}
                strokeWidth="0"
                onClick={item.selectArc}
                onPress={item.selectArc}
                // hover
                onMouseEnter={() => {
                  setHovered(true);
                }}
                onMouseLeave={() => setHovered(false)}
              />
              {hovered && (
                <Text
                  textAnchor="middle"
                  translate={item.textPosition}
                  fill="#FFFFFF"
                  fontFamily="Poppins_400Regular"
                  fontSize="13px"
                  fontWeight="600"
                  onClick={item.selectArc}
                  onPress={item.selectArc}>
                  {item.item.percentage} %
                </Text>
              )}
            </G>
          );
        })}
      </Svg>
    </View>
  );
};

enum StyleName {
  emptyContainer = 'emptyContainer',
  emptyChart = 'emptyChart',
  emptyChartInnerRadius = 'emptyChartInnerRadius',
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  emptyContainer: {},
  emptyChart: {
    width: '100%',
    height: '100%',
    backgroundColor: '$borderPrimary',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  emptyChartInnerRadius: {
    position: 'absolute',
    width: '50%',
    height: '50%',
    backgroundColor: '$backgroundPrimary',
    borderRadius: '50%'
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center'
  }
};
